/* eslint-disable security/detect-object-injection */
import React, { useContext, useEffect, useState } from 'react';
import AnimatedPageFade from '../../components/Animations/AnimatedPageFade';
import ApplicationContext from '../../context/ApplicationContext';
import AnimatedImage from '../../components/Animations/AnimatedImage';
import AnimatedButton from '../../components/Button';
import ThreeDotsBlackLoader from '../../components/LoadingDots/ThreeDotsBlack';
import { generateDeviceFingerprint } from '../../helpers/CommonFunctions';
import { dataService } from '../../services/data.service';
import moment from 'moment-timezone';
import { reviewLanguageContent } from './reviewLanguageContent';
import { backNextLanguageContent } from '../../components/Button/backNextLanguageContent';
import { documentsLanguageContent } from '../Documents/documentsLanguageContent';

function Review(props) {
    const { handlePage, sessionData, idCardData, insurances, insurancePreference, selectedLanguage, setLoading } = useContext(ApplicationContext);
    const [loader, setLoader] = useState(false);
    const [documents, setDocuments]  = useState([]);
    const [pageLoading, setPageLoading] = useState(false);

    const handleSubmit = () => {
        setLoader(true);
        const payload = {
            "patient_id": sessionData.patient_id,
            "fingerprint_id": generateDeviceFingerprint(),
            "appointment_status": "Completed",
            "appointment_date": moment(sessionData.appointment_date).format('MMM DD, YYYY'),
            "appointment_time": `${moment(sessionData.appointment_date).tz(Intl.DateTimeFormat().resolvedOptions().timeZone).format('hh:mm A z')}`,
        }
        dataService.changeAppointmentStatus(sessionStorage.getItem('session'), payload).then((res) => {
            if(res.error === false) {
                handlePage('thankyou', '', 'false', '')
            }
        })
    }

    const handleEdit = () => {
        handlePage('identity', '', '0', 'previous');
    }

    const handleDocumentLoad = () => {
        setPageLoading(true);
        let tempDocuments =  [];
        dataService.listQueuedDocuments(sessionStorage.getItem('session')).then((res) => {
            if(res.error === false) {
                res.data.data.forEach((item) => {
                    if(item.is_document_packet === true) {
                        tempDocuments.push(...item.forms);
                    } else {
                        tempDocuments.push(item)
                    }
                })
                setDocuments(tempDocuments);
                setPageLoading(false);
            }
        })
    };
    
    const handleViewDocuments = () => {
        setLoading(true);
        handlePage('documents', '', '', 'previous', null, null, {
            pagination_index: 1,
            document_index: 1,
            current_packet_documents: 0,
            current_document_id : documents[0].form_id,
            visited_packet_form_index: 0
        });
    }

    useEffect(() => {
        if(sessionData.documents_count > 0) {
            handleDocumentLoad();
        }
    }, [])

    return (
        <AnimatedPageFade className='flex flex-col justify-between relative h-welcome gradient-bg rounded-[16px] overflow-hidden'>
            <div className='p-[8px]' data-testid="review_page">
                <p className='text-center font-semibold text-[#64A003] text-[24px] border-b border-[#D7D7D7] py-[8px] lg:text-[26px] xl:text-[32px] 2xl:text-[38px] flex justify-center items-center pb-[10px]'>
                    <AnimatedImage url="/images/review.svg" alt="review" className="mr-[12px]" />
                    {reviewLanguageContent['review'][selectedLanguage]}
                </p>
                {reviewLanguageContent['review-content'][selectedLanguage]}
                <div className='mt-[16px]'>
                    <div className='flex items-center justify-between'>
                        <div className='flex items-center'>
                            <img src="/images/umbrella-black.svg" alt="id-insurance" />
                            <p className='text-base font-semibold ml-[8px]'>{reviewLanguageContent['id-insurance'][selectedLanguage]}</p>
                        </div>
                        <button data-testid="edit_button" onClick={() => handleEdit()} className='text-[#F2F2F2] bg-black w-fit py-[5px] px-[20px] 
                            items-center justify-center text-base font-semibold rounded-[49px] h-[32px]'>{reviewLanguageContent['edit'][selectedLanguage]}</button>
                    </div>
                    <div className='mt-[16px] border-b border-t border-[#70B503] pt-[12px]'>
                        <div className="overflow-x-hidden overflow-y-auto insurance-height Form-scroll pr-1">
                            {(idCardData.is_idenity_present === true && idCardData.card_type !== '')?
                                <div className='pb-[12px] flex items-start'>
                                    <span className='text-white bg-[#007EB4] rounded-[50%] py-[5px] px-[10px] text-sm font-semibold'>1</span>
                                    <div className='w-full'>
                                        <div className='flex w-full'>
                                            <p data-testid="card_type" style={{overflowWrap: 'anywhere'}} className='text-[#007EB4] text-sm font-semibold ml-[16px] mr-[18px] w-[40%] pb-1'>{idCardData.card_type}</p>
                                            <p style={{overflowWrap: 'anywhere'}} data-testid="card_issuer_card_number" className='text-[#333] text-sm font-semibold mr-[25px] w-[60%]'>{idCardData.card_issuer} ~ {idCardData.card_number}</p>
                                        </div>
                                    </div>
                                </div>
                                : <div className='pb-[12px] flex items-start'>
                                    <span className='text-white bg-[#007EB4] rounded-[50%] py-[5px] px-[10px] text-sm font-semibold'>1</span>
                                    <div className='w-full'>
                                        <div className='flex w-full pt-[5px]'>
                                            <p style={{overflowWrap: 'anywhere'}} className='text-[#007EB4] text-sm font-semibold ml-[16px] mr-[18px] w-[40%] pb-1'>{reviewLanguageContent['ID'][selectedLanguage]}</p>
                                            <p style={{overflowWrap: 'anywhere'}} data-testid="identity_not_provided" className='text-[#333] text-sm font-semibold w-[60%] mr-[25px]'>{reviewLanguageContent['not-provided'][selectedLanguage]}</p>
                                        </div>
                                    </div>
                                </div>}
                            {insurancePreference.is_insurance_exists === 'Yes' ?
                                insurances.map((item, index) => (
                                    <div key={`insurance-${index}`} className='pb-[12px] flex items-start w-full'>
                                        <span className='text-white bg-[#007EB4] rounded-[50%] py-[5px] px-[10px] text-sm font-semibold'>{index + 2}</span>
                                        <div className='w-full'>
                                            <div className='flex w-full pt-[5px]'>
                                                <p style={{overflowWrap: 'anywhere'}} className='text-[#007EB4] text-sm font-semibold ml-[16px] mr-[18px] w-[40%] pb-2'>{reviewLanguageContent['insurance'][selectedLanguage]}</p>
                                                <p style={{overflowWrap: 'anywhere'}} data-testid="insurance_carrier" className='text-[#333] text-sm font-semibold w-[60%] mr-[25px]'>{item.carrier}</p>
                                            </div>
                                            <div className='flex w-full'>
                                                <p style={{overflowWrap: 'anywhere'}} className='text-[#007EB4] text-sm font-semibold ml-[16px] mr-[18px] w-[40%] pb-2'>{reviewLanguageContent['policy'][selectedLanguage]}</p>
                                                <p style={{overflowWrap: 'anywhere'}} data-testid="policy_number" className='text-[#333] text-sm font-semibold w-[60%] mr-[25px]'>{item.mandatory_id}</p>
                                            </div>
                                            <div className='flex w-full'>
                                                <p style={{overflowWrap: 'anywhere'}} className='text-[#007EB4] text-sm font-semibold ml-[16px] mr-[18px] w-[40%] pb-2'>{reviewLanguageContent['holder'][selectedLanguage]}</p>
                                                <p style={{overflowWrap: 'anywhere'}} data-testid="policy_holder_name" className='text-[#333] text-sm font-semibold w-[60%] break-words mr-[25px]'>{item.policy_holder_name}</p>
                                            </div>
                                        </div>
                                    </div>
                                ))
                                : 
                                <div className='pb-[12px] flex items-start'>
                                    <span className='text-white bg-[#007EB4] rounded-[50%] py-[5px] px-[10px] text-sm font-semibold'>2</span>
                                    <div className='w-full'>
                                        <div className='flex w-full pt-[5px]'>
                                            <p style={{overflowWrap: 'anywhere'}} className='text-[#007EB4] text-sm font-semibold ml-[16px] mr-[18px] w-[40%] pb-1'>{reviewLanguageContent['insurance'][selectedLanguage]}</p>
                                            <p style={{overflowWrap: 'anywhere'}} data-testid="insurance_not_provided" className='text-[#333] text-sm font-semibold w-[60%] mr-[25px]'>{reviewLanguageContent['not-provided'][selectedLanguage]}</p>
                                        </div>
                                    </div>
                                </div>}
                        </div>
                    </div>
                    {pageLoading && <div className='mt-[24px]'>
                        <div className='flex items-center justify-between'>
                            <div className='flex items-center'>
                                <img src="/images/black-docs.svg" alt="documents" />
                                <p className='text-base font-semibold ml-[8px]'>{documentsLanguageContent['documents'][selectedLanguage]}</p>
                            </div>
                        </div>
                        <div className='mt-[16px] border-b border-t border-[#70B503] pt-[12px] animate-pulse'>
                            {[...Array(3)].map((item, index) => (
                                <div className='h-[20px] rounded-lg w-full bg-slate-300 my-2' key={index} />
                            ))}
                        </div>
                    </div>}
                    {!pageLoading && sessionData.documents_count > 0 && 
                    <div className='mt-[24px]'>
                        <div className='flex items-center justify-between'>
                            <div className='flex items-center'>
                                <img src="/images/black-docs.svg" alt="documents" />
                                <p className='text-base font-semibold ml-[8px]'>{documentsLanguageContent['documents'][selectedLanguage]}</p>
                            </div>
                            <button data-testid="review_document" onClick={() => handleViewDocuments()} className='text-[#F2F2F2] bg-black w-fit py-[5px] px-[16px] 
                            items-center justify-center text-base font-semibold rounded-[49px] h-[32px]'>{reviewLanguageContent['view'][selectedLanguage]}</button>
                        </div>
                        <div className='mt-[16px] border-b border-t border-[#70B503] pt-[12px]'>
                            <div className="overflow-x-hidden overflow-y-auto insurance-height Form-scroll pr-1">
                                {documents.length > 0 && documents.map((item, index) => (
                                    <div key={`document-${index}`} className='pb-[12px] flex items-start w-full'>
                                        <span className='text-white bg-[#007EB4] rounded-[50%] py-[5px] px-[10px] text-sm font-semibold mr-[16px]'>{index + 1}</span>
                                        <div className='w-full'>
                                            <div className='flex w-full pt-[5px]'>
                                                <p style={{overflowWrap: 'anywhere'}} data-testid="document_name" className='text-[#333] text-sm font-semibold w-[60%] mr-[25px] flex items-center'>{item.form_name || item.name} 
                                                    {item.status === 'Pending' && <img className="ml-2 mt-0.5" src="/images/form-required.svg" />}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                    }
                </div>
            </div>
            <div className='flex mb-[24px] justify-center mx-[16px] w-auto fold-gap'>
                <AnimatedButton disabled={loader}
                    handleClick={() => handleSubmit()}  id="done_button" className={`font-semibold fold-normal-text text-gray w-[200px] h-[40px] ${loader ? '' : 'pl-[41px]'} bg-[#F2F2F2] text-[16px] md:text-[18px] lg:text-[18px] xl:text-[18px] 2xl:text-[18px] justify-center`}>
                    {loader ? <ThreeDotsBlackLoader /> : backNextLanguageContent['done'][selectedLanguage]}
                    {!loader && <img src="/images/next.svg" alt="next" className='ml-[1.5em] w-[1.7em] h-[1.7em]' />}
                </AnimatedButton>
            </div>
        </AnimatedPageFade>
    );
}

export default Review;